// extracted by mini-css-extract-plugin
export var paginationContainer = "_ad-0";